/**
 * Created by Florin David on 07/10/2016.
 */
import { combineReducers } from 'redux'

import version from './version'
import intl from './intl'
import error from './error'
import update from './update'
import offline from './offline'
import productFamily from './productFamily'
import question from './question'
import response from './response'
import chatHistory from './chatHistory'
import sessionId from './sessionId'
import fetchingResponse from './fetchingResponse'
import auth from './auth'
import search from './search'
import Action, { RESET_STATE } from 'constants/action-types'

const appReducer = combineReducers({
  version,
  intl,
  error,
  update,
  offline,

  productFamily,
  question,
  response,
  chatHistory,
  sessionId,
  fetchingResponse,
  auth,
  search,
})

export type State = ReturnType<typeof appReducer>

export default (
  state: ReturnType<typeof appReducer>,
  action: Action,
): ReturnType<typeof appReducer> => {
  if (action.type === RESET_STATE) {
    state = action.payload as ReturnType<typeof appReducer>
  }

  return appReducer(state, action)
}
